import React, {useEffect, useState} from 'react';
import {DataGrid, GridOverlay, GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import {getAllScanSerialNoData} from '../../../services/asset.service';
import * as CryptoJS from "crypto-js";
import Box from "@mui/material/Box";
import {Pagination} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "react-select";
import '../../ExcelUploads/AssetInfo/AssetList.css';

/* ─── Date Helper (unchanged) ─── */
function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

const CustomLoader = () => (
    <GridOverlay>
        <CircularProgress color="primary" size={30}/>
    </GridOverlay>
);

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport 
                csvOptions={{
                    fileName: 'scan_serial_no_list',
                }}
            />
        </GridToolbarContainer>
    );
}

const calculateOffset = (page, pageSize) => (page - 1) * pageSize;

function ViewScanSerialNo() {
    /* ─── All State (unchanged) ─── */
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(50);

    /* ─── Columns (backend unchanged – only styling updated) ─── */
    const columns = [
        {field: "id", editable: false, hide: false, headerName: "SNo.", width: 50},
        {field: "batch_no", editable: false, hide: false, headerName: "Batch No", width: 100},
        {field: "supplier_name", editable: false, hide: false, headerName: "Supplier Name", width: 250},
        {field: "invoice_no", editable: false, hide: false, headerName: "Invoice no", width: 150},
        {
            field: "invoice_date", editable: false, hide: false, headerName: "Invoice Date", width: 120,
            renderCell: (params) => <p>{getFormatedDate(params.row.invoice_date)}</p>
        },
        {field: "no_of_records", editable: false, hide: false, headerName: "No of Records", width: 130},
        {
            field: "date_of_creation", editable: false, hide: false, headerName: "Date of Addition", width: 150,
            renderCell: (params) => <p>{getFormatedDate(params.row.date_of_creation)}</p>
        },
        {field: "created_by_name", editable: false, hide: false, headerName: "Created By User Name", width: 180},
        {
            field: 'actions', headerName: 'Actions', width: 170, renderCell: (params) => {
                let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
                    'scanid': params.row.id,
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return (
                    <a href={`/view-scan-tag-list/?scan_ID=${EncryptID}`}>
                        <button type="button" className="al-btn al-btn-primary al-btn-sm" style={{margin: '4px 0'}}>
                            <i className="bi bi-eye-fill"/> View/Download
                        </button>
                    </a>
                );
            }
        }
    ];

    /* ─── Data Fetching (unchanged logic) ─── */
    useEffect(() => {
        const offset = calculateOffset(page, pageSize);
        const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {'offset': offset, 'pageSize': pageSize},
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        let oData = {'token': EncryptData};

        getAllScanSerialNoData(oData).then(res => {
            if (res?.data?.data?.length) setItems(res.data.data);
            setTotalItems(res.data.total || 0);
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }, [page, pageSize]);

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const totalPages = Math.ceil(totalItems / pageSize);

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="scan-serial-no-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-upc-scan"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Scan Serial Number List</h5>
                        <p className="al-page-subtitle">View scanned serial number batches and records</p>
                    </div>
                </div>
                {!loading && items.length > 0 && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-layers-fill"/>
                        <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Records
                    </div>
                )}
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table"/> Scan Batch Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> of <strong>{totalItems.toLocaleString('en-IN')}</strong>
                        </span>
                    )}
                </div>

                <Box>
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.id}
                        columns={columns}
                        autoHeight
                        className="al-data-grid"
                        components={{
                            LoadingOverlay: CustomLoader,
                            Toolbar: CustomToolbar,
                            Pagination: () => (
                                <Box className="al-pagination-bar">
                                    <div className="al-page-size-row">
                                        <span className="al-page-size-label">Rows per page</span>
                                        <Select
                                            options={[
                                                {value: 50, label: '50'},
                                                {value: 100, label: '100'},
                                                {value: 200, label: '200'},
                                                {value: 500, label: '500'},
                                            ]}
                                            value={{value: pageSize, label: pageSize.toString()}}
                                            onChange={(selected) => handlePageSizeChange(selected.value)}
                                            classNamePrefix="al-select"
                                            menuPlacement="top"
                                            styles={{container: (base) => ({...base, minWidth: 80})}}
                                        />
                                    </div>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        size="small"
                                    />
                                </Box>
                            ),
                        }}
                        loading={loading}
                        sx={{
                            border: 'none',
                            fontFamily: "var(--font-body)",
                            '& .MuiDataGrid-columnHeaders': {
                                color: '#fff',
                                fontSize: '0.75rem',
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                borderBottom: 'none',
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {color: '#000',fontSize: '0.88rem'},
                            '& .MuiDataGrid-sortIcon': {color: 'rgb(46 45 45 / 85%)'},
                            '& .MuiDataGrid-menuIconButton': {color: 'rgb(46 45 45 / 85%)'},
                            '& .MuiDataGrid-iconButtonContainer .MuiIconButton-root': {color: 'rgba(255,255,255,0.85)'},
                            '& .MuiDataGrid-row': {fontSize: '0.8rem'},
                            '& .MuiDataGrid-row:hover': {backgroundColor: '#eef7fd'},
                            '& .MuiDataGrid-row.Mui-selected': {backgroundColor: '#d8f0fa'},
                            '& .MuiDataGrid-cell': {borderColor: '#f0f2f5'},
                            '& .MuiDataGrid-footerContainer': {borderTop: '1px solid #e2e6ef', background: '#f8f9fc'},
                            '& .MuiDataGrid-virtualScroller': {backgroundColor: '#fff'},
                            '& .MuiDataGrid-toolbarContainer': {
                                padding: '12px 16px',
                                borderBottom: '1px solid #e2e6ef',
                                '& .MuiButton-root': {
                                    color: '#0e8aca',
                                    fontWeight: 600,
                                    fontSize: '0.8rem',
                                    '&:hover': {
                                        backgroundColor: 'rgba(14, 138, 202, 0.08)',
                                    }
                                }
                            }
                        }}
                    />
                </Box>
            </div>
        </div>
    )
}

export default ViewScanSerialNo;